module.exports = __webpack_public_path__ + "img/343.04043508.png";